import React from 'react';
import { motion } from 'framer-motion';
export function RevelationSection() {
  return <section className="py-24 px-4 bg-brand-black relative overflow-hidden" data-id="element-168">
      {/* Background accent */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-brand-red/5 blur-3xl pointer-events-none" data-id="element-169"></div>

      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-170">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-171">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="text-right border-r-4 border-gray-800 pr-8 py-8" data-id="element-172">
            <h3 className="text-gray-500 font-heading text-2xl uppercase mb-2" data-id="element-173">
              El Error
            </h3>
            <p className="text-xl text-gray-400 mb-4" data-id="element-174">
              Cuando operás desde el <br data-id="element-175" />
              <span className="text-white font-bold" data-id="element-176">Marco de Aprobación</span>:
            </p>
            <p className="text-3xl font-bold text-gray-300" data-id="element-177">Buscás gustar.</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="text-left pl-4 py-8" data-id="element-178">
            <h3 className="text-brand-red font-heading text-2xl uppercase mb-2" data-id="element-179">
              La Solución
            </h3>
            <p className="text-xl text-white mb-4" data-id="element-180">
              Cuando operás desde <br data-id="element-181" />
              <span className="text-brand-gold font-bold" data-id="element-182">Código Deseo™</span>:
            </p>
            <p className="text-4xl font-bold text-white" data-id="element-183">Activás tensión.</p>
            <p className="text-sm text-brand-gold mt-2 uppercase tracking-widest" data-id="element-184">
              Y la tensión genera deseo.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center" data-id="element-185">
          <h2 className="text-4xl md:text-6xl font-heading font-bold text-white uppercase" data-id="element-186">
            La atracción no es actitud.
            <br data-id="element-187" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400" data-id="element-188">
              Es estructura.
            </span>
          </h2>
        </motion.div>
      </div>
    </section>;
}